import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import truncate from 'lodash/truncate';
import cover from './../NewProjectCard/cover.svg';

export const ActiveCard = ({ project, handleGoToProjectView }) => {
  const projectName = project.project_name
    ? truncate(project.project_name, { length: 25 })
    : 'Real Estate Video';

  return (
    <div className="col-12 col-md-6 col-lg-4 mb-4">
      <div className="card border-0 card-project card-project-pending">
        <div
          className="card-img-top card-img-top-bg position-relative cursor-pointer"
          style={{
            backgroundImage: `url(${project.project_picture || cover})`,
          }}
          onClick={() => handleGoToProjectView(project)}
        />
        <div className="card-body">
          <div className="row justify-content-between">
            <div className="col-10">
              <h4 className="t-20 text-darkgreen">{projectName}</h4>
            </div>
            <div className="col-2" />
          </div>
          <p className="t-12 text-gray-light">
            {`Last Update: ${createFormattedDate(project.updated_at)(
              'DD MMM YYYY',
            )}`}
          </p>
        </div>
      </div>
    </div>
  );
};

const createFormattedMoment = date => moment(date, 'YYYY-MM-DD');

const createFormattedDate = date => format =>
  createFormattedMoment(date).format(format);

ActiveCard.propTypes = {
  project: PropTypes.shape({
    project_name: PropTypes.string,
    updated_at: PropTypes.string,
    price_selected: PropTypes.number,
    bid_info: PropTypes.shape({
      last_bid_created_at: PropTypes.string,
    }),
    bids: PropTypes.array,
  }),
  handleGoToProjectView: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/DashboardCard/ActiveCard/ActiveCard.js